// extracted by mini-css-extract-plugin
export default {"cardWrapper":"AllergiesIntolerance_cardWrapper__K71po"};